import React from "react";
import { Raffle } from "../../../types/raffle";
import CloseIcon from "@material-ui/icons/Close";

interface BonusRafflesFieldProps {
  raffles: Array<Raffle>;
  removeRaffle: (raffleId: string) => void;
  error: boolean;
}

export const BonusRafflesField = ({
  raffles,
  removeRaffle,
  error,
}: BonusRafflesFieldProps) => {
  return (
    <div className={error ? "bonus-raffle-field error" : "bonus-raffle-field"}>
      {raffles && raffles.length ? (
        raffles.map((raffle) => {
          return (
            <div className="bonus-raffle-field__item" key={raffle._id}>
              <span className="bonus-raffle-field__item-title">
                {raffle.title}
              </span>
              {raffle.active && (
                <span className="bonus-raffle-field__item-active">active</span>
              )}
              <button
                onClick={() => removeRaffle(raffle._id)}
                type="button"
                className="bonus-raffle-field__item-remove"
              >
                <CloseIcon />
              </button>
            </div>
          );
        })
      ) : (
        <p className="bonus-raffle-field__label">no Associated Raffles...</p>
      )}
    </div>
  );
};
